import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=591e60ca&"
import script from "./flight.vue?vue&type=script&lang=js&"
export * from "./flight.vue?vue&type=script&lang=js&"
import style0 from "./flight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports